export default {
  title: {
    en: 'Who is this gift for?',
  },
  hint: {
    en: 'Write a personal message',
  },
  nameLabel: {
    en: 'Enter recipient name',
  },
  emailLabel: {
    en: 'Enter recipient email',
  },
}
